import type { ReactNode } from "react";
import { cn } from "../lib/utils";

interface CardProps {
  title: string;
  value?: string;
  icon: ReactNode;
  progressLabel?: string;
  progressDetail?: string;
  className?: string;
  titleClassName?: string;
  valueClassName?: string;
  progressLabelClassName?: string;
  progressDetailClassName?: string;
}

export default function Card({
  title,
  value,
  icon,
  progressLabel,
  progressDetail,
  className,
  titleClassName,
  valueClassName,
  progressLabelClassName,
}: CardProps) {
  return (
    <div
      className={cn(
        "bg-white rounded-lg p-4 shadow-sm border border-gray-100",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <div className="bg-red-50 rounded-md p-2">{icon}</div>
        <span className={cn("text-sm text-gray-400 uppercase", titleClassName)}>
          {title}
        </span>
      </div>
      <div className="pt-2">
        <div className="flex items-end gap-2">
          <p className={cn("text-xl text-gray-900", valueClassName)}>
            {value}
            <span className="text-sm text-gray-400"> {progressDetail}</span>
          </p>
          {progressLabel && (
            <span
              className={cn(
                "text-xs text-gray-400 pb-1",
                progressLabelClassName,
              )}
            >
              {progressLabel}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
